import {useCurrentBreakpoint} from '@travel-frontend/core';
import {
  type BannerProps as GenericBannerProps,
  Banner as GenericBannerUI,
  useBooleanToggle,
} from '@travel-frontend/ui-components';

import {ConditionsLayer} from '@/components/ConditionsLayer';

const breakpointMap = {
  xs: 'sm',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'lg',
} as const;

export const GenericBanner = ({
  conditionsId,
  ...restProps
}: GenericBannerProps & {
  conditionsId?: {sm: string; md: string; lg: string};
}) => {
  const [isOpen, toggleIsOpen] = useBooleanToggle();
  const currentBreakpoint = useCurrentBreakpoint();
  const bp = breakpointMap[currentBreakpoint];

  return (
    <>
      <GenericBannerUI
        {...restProps}
        onClick={() => {
          if (conditionsId && conditionsId[bp]) {
            toggleIsOpen(true);
          }
        }}
      />
      {conditionsId && (
        <ConditionsLayer
          identifier={conditionsId[bp]}
          open={isOpen}
          onClose={() => toggleIsOpen(false)}
        />
      )}
    </>
  );
};
